import { ContestStatusType } from "../../apis/contestApi";

export const getStatusColorByStatusName = (statusName: ContestStatusType) => {
  switch (statusName) {
    case "pending":
      return "#163737";
    case "completed":
      return "tomato";
    case "paused":
      return "#36454f";
    case "created":
      return "#ffb703";
    default:
      return "#163737";
  }
};
